import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, preselectedVariantSku, onVariantSwipe } = props;
  const allImages = listing.images || [];

  // The hero always carries the FULL image set so it stays swipeable — the
  // old behaviour filtered a variant listing down to the active colourway's
  // photo(s), which left nothing to swipe. The gallery and the variant picker
  // stay in TWO-WAY sync: picking a variant slides the gallery to that
  // colourway's photo (slideIndex), and swiping to a photo owned by another
  // colourway reports it back (onVariantSwipe) so the picker highlight
  // follows. Parallel-SKU listings (no publicData.variants) render exactly
  // as before.
  const variants = listing?.attributes?.publicData?.variants;
  const activeVariant =
    Array.isArray(variants) && preselectedVariantSku
      ? variants.find(v => v?.sku === preselectedVariantSku)
      : null;
  const variantImageIds = Array.isArray(activeVariant?.images) ? activeVariant.images : [];
  const variantImageIndex = variantImageIds.length
    ? allImages.findIndex(img => img?.id?.uuid === variantImageIds[0])
    : -1;
  const startIndex = Math.max(0, variantImageIndex);
  const slideIndex = variantImageIndex >= 0 ? variantImageIndex : null;

  const handleSlide = idx => {
    if (typeof onVariantSwipe !== 'function' || !Array.isArray(variants)) return;
    const uuid = allImages[idx]?.id?.uuid;
    if (!uuid) return;
    const owner = variants.find(v => Array.isArray(v?.images) && v.images[0] === uuid);
    if (owner?.sku && owner.sku !== preselectedVariantSku) onVariantSwipe(owner.sku);
  };

  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={allImages}
        startIndex={startIndex}
        slideIndex={slideIndex}
        onSlide={handleSlide}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </section>
  );
};

export default SectionGallery;
